import React from 'react';

const Term = () => {
    return (
        <iframe className="term"  src="https://zeely.app/termContent.html" frameborder="0"></iframe>
    );
}

export default Term;
